module.exports = __webpack_public_path__ + "static/media/hint.400bc589.png";